<script>
/* eslint-disable no-undef */
import axios from 'axios'
import Vue from 'vue'

export default {
    name: 'BaseApp',
    data: function () {

        const t = this;

        const domain = process.env.VUE_APP_DOMAIN !== undefined ? process.env.VUE_APP_DOMAIN : ''
        const isProd = location.href.search('mango-office') > -1;

        return {
            domain: domain,
            apiUrl: domain + '/api/' + t.pascalCaseToKebab(t.$options.name) + '/',
            isProd: isProd
        }
    },
    methods: {
        initData(additionalSendData, actionApi = '') {
            this.$root.getDataElement = this.getDataElement;

            return new Promise((resolve, reject) => {
                const t = this;
                const dataVarName = t.$options.name + 'Data'
                if (Object.hasOwnProperty.call(window, dataVarName) && window[dataVarName]) {
                    // Заполняем данные из глобальной переменной
                    for (let key in window[dataVarName]) {
                        t[key] = window[dataVarName][key];
                    }

                    window[dataVarName] = null;

                    t.$nextTick(function () {
                        resolve()
                    })
                } else {
                    // Заполняем данные через АПИ
                    let sendData = {
                        action: 'getData',
                        sessid: t.sessid
                    }
                    if (typeof additionalSendData === 'object') {
                        Object.assign(sendData, additionalSendData);
                    }

                    if (actionApi) {
                        actionApi = actionApi + '/'
                    }

                    axios.post(t.domain + '/api/' + t.pascalCaseToKebab(t.$options.name) + '/' + actionApi, null, {
                        params: sendData,
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest'
                        }
                    })
                        .then(function (response) {
                            if (actionApi) {
                                for (let key in response.data.data) {
                                    if (key !== 'status') {
                                        t[key] = response.data.data[key]
                                    }
                                }
                            } else {
                                for (let key in response.data) {
                                    if (key !== 'status') {
                                        t[key] = response.data[key]
                                    }
                                }
                            }

                            t.$nextTick(function () {
                                resolve()
                            })
                        })
                        .catch(() => {
                            reject()
                        });
                }
            })
        },

        pascalCaseToKebab(string) {
            const camelCaseString = string.charAt(0).toLowerCase() + string.slice(1);
            return camelCaseString.replace(/[A-Z]?([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();
        },
        getDataElement(elementId) {
            return this.isProd === false ? elementId : null;
        },

        mountApp(App) {
            const t = this;
            Vue.config.productionTip = false
            if (process.env.NODE_ENV === 'production') {
                new Vue(App).$mount('#' + t.pascalCaseToKebab(App.name))
            } else {

                let meta = document.createElement('meta');
                meta.name = 'viewport';
                meta.content = 'width=device-width, initial-scale=1.0, user-scalable=no';
                document.head.appendChild(meta);

                // let script = document.createElement('script')
                // script.src = process.env.VUE_APP_DOMAIN + 'uikit/js/init.min.js'
                // document.body.appendChild(script);

                document.body.className = 'm-ui';


                new Vue({
                    render: createElement => createElement(App)
                }).$mount('#'+t.pascalCaseToKebab(App.name))


                //new Vue(App).$mount('#app')
            }
        },

        isEcommerceArrayExists(r) {
          if (typeof window.mgoTriggerEvent === 'undefined') {
            return false;
          }

          return Object.prototype.hasOwnProperty.call(r, 'arrEcommerce');
        },
        runViewProductEcommerceEvents(r) {
          if (!this.isEcommerceArrayExists(r)) {
            return;
          }

          if (Object.prototype.hasOwnProperty.call(r.arrEcommerce, 'yandex')) {
            window.mgoTriggerEvent('viewProduct', [r.arrEcommerce['yandex']]);
          }
        },
        runAddOrDelProductCartEcommerceEvents(r) {
          if (!this.isEcommerceArrayExists(r)) {
            return;
          }

          if (Object.prototype.hasOwnProperty.call(r.arrEcommerce, 'yandex')) {
            window.mgoTriggerEvent('addOrDelProductCart', [r['arrEcommerce']['yandex']]);
          }
        },
        runOrderEcommerceEvents(r) {
          if (!this.isEcommerceArrayExists(r)) {
            return;
          }

          if (Object.prototype.hasOwnProperty.call(r.arrEcommerce, 'yandex')) {
            window.mgoTriggerEvent('orderEcommerce', [r['arrEcommerce']['yandex']]);
          }
        },
        setNumbersLocationClick() {
            if (typeof window.mgoTriggerEvent !== 'function') {
                return;
            }

            window.mgoTriggerEvent('numbers_location_click');
        }
    }
}
</script>